import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsSV: CultureInfo = {
  name: 'es-SV',
  displayName: 'Spanish (El Salvador)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-SV',
  parent: CultureInfoEs
};
